import { Card, styled } from '@driftt/dds'

export const StyledCard = styled(Card, {
  width: '100%',
  height: '100%',
  maxHeight: '500px',
  padding: '$3',
})
